import { useGetUsersUserIdOauthConnectionsSuspense } from "api/generated/users/users";

export function useOAuthConnectionsQuery(userId: number) {
    return useGetUsersUserIdOauthConnectionsSuspense(userId, {
        query: {
            select: (response) => response.data,
            refetchOnMount: true,
            refetchOnWindowFocus: true,
        },
    });
}
